import { render, staticRenderFns } from "./MedicinesUpload.vue?vue&type=template&id=22c35590"
import script from "./MedicinesUpload.vue?vue&type=script&lang=js"
export * from "./MedicinesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports